import { Component, ViewEncapsulation, ChangeDetectionStrategy, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UxEuLanguages, UxLanguage } from '@eui/base';

import { DYNAMIC_COMPONENT_CONFIG } from '../../../services/eui-dynamic-component.service';
import { EuiDialogService } from '../../../components/eui-dialog';

@Component({
    selector: 'eui-modal-selector',
    templateUrl: './modal-selector.component.html',
    styleUrls: ['../_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})

export class EuiModalSelectorComponent implements OnInit {

    private selectedLanguage: UxLanguage;

    languageRows: UxLanguage[][] = [];
    additionaLanguageRows: UxLanguage[][] = [];

    constructor(private euiDialogService: EuiDialogService,
                @Inject(DYNAMIC_COMPONENT_CONFIG) public config: {
                    languages: UxLanguage[],
                    selectedLanguage: UxLanguage,
                    matDialogRef: MatDialogRef<any>,
                    languageChanged: (language: UxLanguage) => {},
                }) {}

    ngOnInit() {
        this.languageRows = this.prepareLanguageRows(UxEuLanguages.filterEULanguages(this.config.languages));
        this.additionaLanguageRows = this.prepareLanguageRows(UxEuLanguages.filterNonEULanguages(this.config.languages));
    }

    selectLanguage(languageCode: UxLanguage) {
        if (this.selectedLanguage?.code !== languageCode.code) {
            for (const language of this.config.languages) {
                if (language.code === languageCode.code) {
                    this.selectedLanguage = language;
                    break;
                }
            }
        }

        this.config.languageChanged(languageCode);
        this.euiDialogService.closeDialog(this.config.matDialogRef);
    }

    private prepareLanguageRows(languages: UxLanguage[]): UxLanguage[][] {
        let rows: UxLanguage[][] = [];
        let row: UxLanguage[] = [];

        for (let i = 0; i < languages.length; i ++) {
            if (i % 4 === 0) {
                if (row.length > 0) {
                    rows.push(row);
                    row = [];
                }
            }
            row.push(languages[i]);
        }

        if (row.length > 0) {
            rows.push(row);
        }

        return rows;
    }

}
